import { allergenen } from "@/shared/utils/helpers";
import {
  KitchenTypeEnum,
  MenuDataTagBody,
  MenuDataTagKind,
  VerdictOption,
} from "@/shared/utils/interfaces";

export const menuDataTagKinds: MenuDataTagKind[] = [
  MenuDataTagKind.CATEGORY,
  MenuDataTagKind.PRODUCT,
  MenuDataTagKind.TOPPING_CATEGORY,
  MenuDataTagKind.TOPPING,
  MenuDataTagKind.INGREDIENT,
  MenuDataTagKind.SIZE,
  MenuDataTagKind.VARIANT,
];

export const imageVerdictOptions: VerdictOption[] = [
  VerdictOption.DISH,
  VerdictOption.BRAND,
  VerdictOption.UNCLEAR,
  VerdictOption.NOT_FOOD,
];

// The API only accepts allergens 1 - 14
export const menuDataTagAllergens = allergenen.filter(
  (allergen) => allergen.id <= 14
);

export const kitchenTypeKeys = Object.keys(KitchenTypeEnum).filter((key) =>
  isNaN(Number(key))
);

export const slugify = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100);

export const getMenuDataTagName = (
  tag: Pick<MenuDataTagBody, "name"> | undefined,
  language = "all"
): string | undefined => tag?.name?.[language];
